const AUTH_URL = process.env.VUE_APP_AUTH_URL || "http://103.56.158.194:8003";
const BACKEND_URL = process.env.VUE_APP_BACKEND_URL || "http://103.56.158.194:8006";

export default {
  BACKEND_URL,
  LOGIN: `${AUTH_URL}/login`,

  EXTRAS: `${BACKEND_URL}/extras`,
  EVENTS: `${BACKEND_URL}/events`,
  NOTABLES: `${BACKEND_URL}/notables`,
  ARTIFACTS: `${BACKEND_URL}/artifacts`,
  DOCUMENTS: `${BACKEND_URL}/documents`,

  TAGS: `${BACKEND_URL}/tags`,
  FILES: `${BACKEND_URL}/files`,
  UPLOAD: `${BACKEND_URL}/upload`,
  PROJECTS: `${BACKEND_URL}/projects`,
  RELATIONS: `${BACKEND_URL}/relations`,
  CATEGORIES: `${BACKEND_URL}/categories`,
  TRANSLATIONS: `${BACKEND_URL}/translations`,
  STORAGE_STATES: `${BACKEND_URL}/storage_states`,
  STORAGE_ORIGINS: `${BACKEND_URL}/storage_origins`,

  ROLES: `${BACKEND_URL}/roles`,
  ACCOUNTS: `${BACKEND_URL}/accounts`,
  PROFILES: `${BACKEND_URL}/profiles`,
  ROLE_USERS: `${BACKEND_URL}/role-users`,
  ROLE_ACCOUNT: `${BACKEND_URL}/role-account`,
  IAM_RESOURCES: `${BACKEND_URL}/iam-resources`,
  SAVED_FILTERS: `${BACKEND_URL}/saved-filters`,
  MANAGEMENT_LOGS: `${BACKEND_URL}/management-logs`,
  DOCUMENT_UTILS: `${BACKEND_URL}/document-utils`,

  CONTRACTS: `${BACKEND_URL}/contracts`,
  CONTRACT_STEPS: `${BACKEND_URL}/contract-steps`,
  CONTRACT_STATUS: `${BACKEND_URL}/contract-status`,
  CONTRACT_ACTIONS: `${BACKEND_URL}/contract-actions`,
  APPROVED_DOCUMENTS: `${BACKEND_URL}/approved-documents`,

  DATA_CONFIG: `${BACKEND_URL}/data-config`,
  ORGANIZATION_SETTINGS: `${BACKEND_URL}/organization-settings`,
};
